module.exports = __webpack_public_path__ + "static/media/codeBlue.df33f2b4.svg";